import React from "react";

const ViewItems = (props) => {
  const {
    items,
    labels
  } = props;

  return (
    <div className='view-items'>
      {(items) ? Object.keys(labels).map((element) => {
        return (
          <div key={`view-row-${element}`} className='my-info-row'>
            <div className='my-info-label'>
              {labels[element]}
            </div>
            <div className='my-info-value'>
              {items[element]}
            </div>
          </div>
        );
      }): ''}

    </div>
  );
}

export default ViewItems;